import { useState } from "react";
import axios from "axios";

function NseRegistration() {
  const [form, setForm] = useState({
    full_name: "",
    pan: "",
    dob: "",
    mobile: "",
    email: "",
    bank_account: "",
    ifsc: "",
    address: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    await axios.post(
      "http://localhost:3004/api/nse/client-register",
      form,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    alert("NSE Registration Submitted");
  };

  return (
    <div className="container py-5">
      <div className="card bg-dark border-warning">
        <div className="card-body">
          <h4 className="text-warning mb-4">NSE Investor Registration</h4>

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="text-warning">Full Name</label>
                <input className="form-control bg-black text-white"
                  name="full_name" onChange={handleChange} />
              </div>

              <div className="col-md-6 mb-3">
                <label className="text-warning">PAN</label>
                <input className="form-control bg-black text-white"
                  name="pan" onChange={handleChange} />
              </div>

              <div className="col-md-6 mb-3">
                <label className="text-warning">Date of Birth</label>
                <input type="date" className="form-control bg-black text-white"
                  name="dob" onChange={handleChange} />
              </div>

              <div className="col-md-6 mb-3">
                <label className="text-warning">Mobile</label>
                <input className="form-control bg-black text-white"
                  name="mobile" onChange={handleChange} />
              </div>

              <div className="col-12 mb-3">
                <label className="text-warning">Address</label>
                <textarea className="form-control bg-black text-white"
                  name="address" onChange={handleChange}></textarea>
              </div>
            </div>

            <button className="btn btn-warning fw-bold w-100">
              Submit to NSE
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default NseRegistration;